<template>
  <v-container class='edi-tool' fluid>
    <div class="my-4">
      <span v-for="item in translationsModels" :key="item.key" class="mr-4">
        <input type="radio" :id="'mode-'+item.key" :value="item.key" v-model="mode" class="mr-1">
        <label :for="'mode-'+item.key">{{ item.text }}</label>
      </span>
    </div>
    <hr>

    <div v-if="mode==='hanbaio'">
      <div class="mt-5">
        <div class="my-3">
          <span v-for="item in translationsMasters" :key="item.key" class="mr-4">
            <input type="radio" :id="item.key" :value="item.key" v-model="masterType" class="mr-1">
            <label :for="item.key">{{ item.text }}</label>
          </span>
        </div>

        <div class="my-3">
          <input type="file" @change="selectMasterFile" accept="text/csv">
        </div>

        <v-btn @click="uploadMaster">{{ translations('editool.upload') }}</v-btn>
      </div>

      <div class="mt-5">
        <div class="my-3">
          <label>{{ translations('editool.next_invoice_number') }}</label>
          <input class="form-control number" type="number" v-model="number" />
        </div>

        <v-btn @click="updateNumber">{{ translations('common.update') }}</v-btn>
      </div>
    </div>

    <div class="mt-5">
      <div class="row">
        <span v-for="item in translationsTypes" :key="item.key" >
          <template v-if="mode==='shintaro' ? item.shintaro === true : item.hanbaio === true" >
            <span class="col-md-4">
              <input type="radio" :id="'type-'+item.key" :value="item.key" v-model="dataType" v-on:change="onChangeRadioDataType()" class="mr-1">
              <label :for="'type-'+item.key">{{ item.text }}</label>
            </span>
          </template>
        </span>
      </div>

      <div class="row" v-if="dataType === 'fba' && mode === 'shintaro'">
        <div class="col-sm-6">
          <label for="">{{ translations('editool.source') }}</label>
          <select class="custom-select" v-model="fromWarehouseId">
          <option
            v-for='(warehouse, i) in dataWarehouses'
            :value="warehouse.id"
            :key='`from-${i}`'>
              {{ warehouse.name }}
          </option>
        </select>

        </div>
        <div class="col-sm-6">
          <label for="">{{ translations('editool.destination') }}</label>
          <select class="custom-select" v-model="toWarehouseId">
            <option
              v-for='(warehouse, i) in dataWarehouses'
              :value="warehouse.id"
              :key='`from-${i}`'>
                {{ warehouse.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="my-3">
        <input type="file" @change="selectDataFile" :accept="mode == 'shintaro' ? 'text/csv,.xls,.xlsx,.txt' : 'text/csv'" ref="inputFile">
      </div>

      <v-btn @click="uploadDataFile">{{ translations('common.update') }}</v-btn>
      <vue-element-loading :active="isPosting" :is-full-screen="true"/>
    </div>
  </v-container>
</template>

<script>
import _ from 'lodash'
import XlsExport from 'xlsexport'
import VueElementLoading from 'vue-element-loading'
import { format } from 'date-fns'
import { mapState } from 'vuex'

export default {
  name: 'EdiTool',
  components: {
    VueElementLoading
  },
  data () {
    return {
      json_fields: {
        'Complete name': 'name',
        'Date': 'date'
      },
      fromWarehouseId: 6,
      toWarehouseId: 43,
      isPosting: false,
      warehouses: null,
      jsonData: [],
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      MODES: [
        { key: 'hanbaio', text: '販売王用CSVダウンロード' },
        { key: 'shintaro', text: '慎太郎用CSVインポート' }
      ],
      MASTERS: [
        { key: 'product', text: '商品台帳' },
        { key: 'customer', text: '得意先台帳' },
        { key: 'shipping', text: '配送先台帳' }
        // { key: 'price', text: '原価表' }
      ],
      TYPES: [
        { key: 'kitchen', text: 'AmazonベンダーKITCHEN', shintaro: true, hanbaio: true },
        { key: 'camera', text: 'AmazonベンダーCAMERA', shintaro: true, hanbaio: true },
        { key: 'ce', text: 'AmazonベンダーCE', shintaro: true, hanbaio: true },
        { key: 'pc', text: 'AmazonベンダーPC', shintaro: true, hanbaio: true },
        { key: 'wireless', text: 'AmazonベンダーWIRELESS', shintaro: true, hanbaio: true },
        { key: 'hi', text: 'アマゾンベンダー SmartHome', shintaro: true, hanbaio: true },
        { key: 'op', text: 'アマゾンベンダー OP', shintaro: true, hanbaio: true },
        { key: 'hpc', text: 'アマゾンベンダー HPC', shintaro: true, hanbaio: true },
        { key: 'seller', text: 'Amazonセラーセントラル', shintaro: true, hanbaio: true },
        { key: 'rakuten', text: '楽天', shintaro: true, hanbaio: true },
        { key: 'incharge_a', text: 'インチャージA', shintaro: true, hanbaio: true },
        { key: 'incharge_b', text: 'インチャージB', shintaro: true, hanbaio: true },
        { key: 'timely', text: 'タイムリー', shintaro: true, hanbaio: true },
        { key: 'geecle', text: 'ギークル', shintaro: true, hanbaio: true },
        { key: 'acros', text: 'アクロス', shintaro: true, hanbaio: true },
        { key: 'hanbaio', text: '販売王', shintaro: true, hanbaio: false },
        { key: 'kaga', text: '加賀ソルネット', shintaro: true, hanbaio: true },
        { key: 'fba', text: 'アマゾン FBA ', shintaro: true, hanbaio: false },
        { key: 'costco', text: 'コストコ', shintaro: true, hanbaio: false },
        { key: 'yamada', text: 'ヤマダ電機', shintaro: true, hanbaio: false },
        { key: 'daiwabo', text: 'ダイワボウCSV', shintaro: true, hanbaio: false },
        { key: 'monotaro', text: 'モノタロウCSV', shintaro: true, hanbaio: false },
        { key: 'yahoo', text: 'YahooCSV', shintaro: true, hanbaio: false }
      ],
      masterFile: [],
      masterType: null,
      dataFile: null,
      dataType: null,
      apiUrl: process.env.VUE_APP_SHINTARO_API_URL,
      number: 0,
      mode: 'hanbaio'
    }
  },

  created () {
    this.getNumber()
  },
  computed: {
    ...mapState(['currentLanguage']),
    dataWarehouses () {
      return this.$store.getters['Master/getMywarehouses']
    },
    translationsModels () {
      return this.MODES.map(mode => ({
        ...mode,
        text: this.translations(`editool.${mode.key}`)
      }))
    },
    translationsMasters () {
      return this.MASTERS.map(master => ({
        ...master,
        text: this.translations(`editool.${master.key}`)
      }))
    },
    translationsTypes () {
      return this.TYPES.map(type => ({
        ...type,
        text: this.translations(`type_editool.${type.key}`)
      }))
    },
    confirmationChooseFile () {
      return this.translations('editool.message_choose_file')
    },
    confirmationDocumentUpdated () {
      return this.translations('editool.message_document_has_been_updated')
    },
    confirmationDocumentUpdateFailed () {
      return this.translations('editool.message_document_update_fail')
    },
    messageError () {
      return this.translations('editool.message_error')
    },
    messageUploadComplete () {
      return this.translations('editool.message_upload_complete')
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    onChangeRadioDataType () {
      let dataType = this.dataType
      if (dataType === 'fba' && this.dataWarehouses.length === 0) {
        this.$store.dispatch('Master/checkMywarehouses').then((item) => {
          let storeWareHouse = this.$store.getters['Master/getMywarehouses']
          this.fromWarehouseId = storeWareHouse[0].id
          let defaultWareHouseTo = _.find(storeWareHouse, function (o) { return o.name === 'アマゾン倉庫' })
          this.toWarehouseId = defaultWareHouseTo ? defaultWareHouseTo.id : null
        })
      }
    },
    getFilterTxt (obj, input, output, _default) {
      if (input) {
        if (input === 0) return _default
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },
    selectMasterFile (e) {
      e.preventDefault()
      const files = e.target.files
      this.masterFile = files[0]
    },
    uploadMaster () {
      if (!this.masterType || this.masterFile.length === 0) {
        alert(this.confirmationChooseFile)
        return
      }
      const formData = new FormData()
      formData.append('file', this.masterFile)
      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }

      this.$http.post(this.apiUrl + '/edi_master_file/' + this.masterType, formData, config).then(response => {
        const result = response.data
        if (!result || result.status !== 'OK') {
          alert(result.message)
        } else {
          alert(this.messageUploadComplete)
        }
      }).catch(err => {
        alert('エラーが発生しました。' + err.message)
      }).finally(() => {
        this.masterFile = []
      })
    },
    selectDataFile (e) {
      e.preventDefault()
      const files = e.target.files
      this.dataFile = files[0]
    },
    uploadDataFile () {
      if (!this.dataType || !this.dataFile) {
        alert(this.confirmationChooseFile)
        return
      }

      const amazonType = ['kitchen', 'camera', 'ce', 'pc', 'wireless', 'hi', 'seller', 'op', 'hpc']
      const ediToolType = ['costco', 'acros', 'yamada', 'daiwabo', 'monotaro', 'yahoo']
      const formData = new FormData()
      formData.append('file', this.dataFile)
      formData.append('mode', this.mode)

      if (this.dataType === 'fba') {
        formData.append('fromWarehouseId', this.fromWarehouseId)
        formData.append('toWarehouseId', this.toWarehouseId)
        formData.append('reference_at', format(new Date(), "yyyy-MM-dd'T'HH:mm:59"))
      }
      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
      this.isPosting = true
      this.$http.post(this.apiUrl + '/edi/' + this.dataType, formData, config).then(response => {
        var FILE = window.URL.createObjectURL(new Blob([response]))

        var docUrl = document.createElement('x')
        docUrl.href = FILE
        docUrl.setAttribute('download', 'file.xls')
        document.body.appendChild(docUrl)
        docUrl.click()
        this.isPosting = false
        const result = response.data
        this.dataFile = null
        this.$refs.inputFile.value = null
        if (result.status !== 'OK') {
          if (result.message) {
            alert(result.message)
          } else {
            alert('コンバートに失敗しました。')
          }
        } else {
          if (this.mode === 'hanbaio') {
            this.save_('hanbaio_import_' + this.dataType, 'text/csv', result.base64)
          } else {
            if (this.dataType === 'fba') {
              if (result.report) {
                let bin = JSON.parse(window.atob(result.base64.replace(/^.*,/, '')))
                let xls = new XlsExport(bin, 'アマゾン FBA')
                xls.exportToXLS('アマゾン FBA ')
                this.$toastr.error('エラーデータが存在しています。', 'エラー')
              } else {
                this.$toastr.success('正常に登録できました。', 'Success')
              }
            } else if (this.mode === 'shintaro' && ediToolType.includes(this.dataType)) {
              if (result.resultError.length > 0) {
                this.$toastr.error('エラーデータが存在しています。', 'エラー')
                var fileName = this.dataType + '_report'
                this.exportToCsv(fileName, result.resultError)
              } else {
                this.$toastr.success('正常に登録できました。', 'Success')
              }
            } else if (this.mode === 'shintaro' && amazonType.includes(this.dataType)) {
              if (result.resultError.length > 0) {
                this.$toastr.error('エラーデータが存在しています。', 'エラー')
                var fileNameAmazon = 'amazon_' + this.dataType + '_report'
                this.exportToCsv(fileNameAmazon, result.resultError)
              } else {
                this.$toastr.success('正常に登録できました。', 'Success')
              }
            } else {
              alert(result.message)
            }
          }
        }
      }).catch(err => {
        alert('予期せぬエラーが発生しました。' + err.message)
      }).finally(() => {
        this.masterFile = []
        this.getNumber()
      })
    },
    exportToCsv (filename, rows) {
      var processRow = function (row) {
        var finalVal = ''
        for (var j = 0; j < row.length; j++) {
          var innerValue = row[j] === null ? '' : row[j].toString()
          if (row[j] instanceof Date) {
            innerValue = row[j].toLocaleString()
          };
          var result = innerValue.replace(/"/g, '""')
          if (result.search(/("|,|\n)/g) >= 0) { result = '"' + result + '"' }
          if (j > 0) { finalVal += ',' }
          finalVal += result
        }
        return finalVal + '\n'
      }

      var csvFile = ''
      for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i])
      }
      var link = window.document.createElement('a')
      link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csvFile))
      link.setAttribute('download', filename)
      link.click()
    },
    save_ (filename, mimetype, base64) {
      // 別タブで開く
      const bin = window.atob(base64.replace(/^.*,/, ''))
      const len = bin.length
      const buffer = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        buffer[i] = bin.charCodeAt(i)
      }
      const blob = new Blob([buffer.buffer], { type: mimetype })

      // ダウンロード
      const a = document.createElement('a')
      a.download = filename
      a.target = '_blank'
      if (window.navigator.msSaveBlob) {
        // for IE
        window.navigator.msSaveBlob(blob, filename)
      } else if (window.URL && window.URL.createObjectURL) {
        if (window.navigator.appVersion.indexOf('Safari') > -1) {
          // for Safari
          a.target = ''
          a.href = window.URL.createObjectURL(blob)
          a.click()
        } else {
          // for Firefox
          a.href = window.URL.createObjectURL(blob)
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
      } else if (window.webkitURL && window.webkitURL.createObject) {
        // for Chrome
        a.href = window.webkitURL.createObjectURL(blob)
        a.click()
      } else {
        // for Safari
      }
    },
    getNumber () {
      this.$http.get(this.apiUrl + '/edi/number').then(response => {
        const result = response.data
        if (!result || !result.success) {
          alert(result.message)
        } else {
          this.number = result.data.nunber
        }
      }).catch(err => {
        alert('エラーが発生しました。' + err.message)
      })
    },
    updateNumber () {
      this.$http.put(this.apiUrl + '/edi/number', { number: this.number }).then(response => {
        const result = response.data
        if (result.status !== 'OK') {
          if (result.message) {
            alert(result.message)
          } else {
            alert(this.confirmationDocumentUpdateFailed)
          }
        } else {
          alert(this.confirmationDocumentUpdated)
        }
      }).catch(err => {
        alert(this.messageError + err.message)
      })
    }
  }
}
</script>

<style>
.edi-tool label{
  margin-bottom:0;
}
.number:before {
  content: 'E';
}
</style>
